import { useContext } from "react";
import { AppContext, IAppContextProps } from "../context";


export const useAppState = (): IAppContextProps => {
    return useContext(AppContext)
}